import { render } from "./listUsers.vue?vue&type=template&id=2c454f94&scoped=true"
import script from "./listUsers.vue?vue&type=script&lang=js"
export * from "./listUsers.vue?vue&type=script&lang=js"

import "./listUsers.vue?vue&type=style&index=0&id=2c454f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c454f94"]])

export default __exports__